import client from 'lib/apiClient';

const BASEURL = 'API/1_0/redirect.php';

export const getRedirects = (query) => client.get(BASEURL, { params: query });

export const getRedirect = (redir_id) =>
  client.get(BASEURL, { params: { redir_id } }).then((resp) => resp[0]);

export const saveRedirect = (data) => client.post(BASEURL, data);

export const deleteRedirect = (redir_url_short) =>
  client.delete(BASEURL, { params: { redir_url_short } });

export const editRedirect = (data) => client.post(BASEURL, data);
